__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "sat-portal-fe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@azure/msal-browser", "3.28.1", () => (Promise.all([__webpack_require__.e(766), __webpack_require__.e(379)]).then(() => (() => (__webpack_require__(1766))))));
			register("@azure/msal-react", "2.2.0", () => (Promise.all([__webpack_require__.e(683), __webpack_require__.e(910)]).then(() => (() => (__webpack_require__(2529))))));
			register("@ey-xd/motif-react", "6.0.0", () => (__webpack_require__.e(7).then(() => (() => (__webpack_require__(3007))))));
			register("@reduxjs/toolkit", "2.8.2", () => (Promise.all([__webpack_require__.e(17), __webpack_require__.e(322)]).then(() => (() => (__webpack_require__(2017))))));
			register("axios", "1.9.0", () => (Promise.all([__webpack_require__.e(182), __webpack_require__.e(760)]).then(() => (() => (__webpack_require__(182))))));
			register("dompurify", "3.2.6", () => (__webpack_require__.e(977).then(() => (() => (__webpack_require__(7977))))));
			register("js-sha256", "0.11.0", () => (__webpack_require__.e(813).then(() => (() => (__webpack_require__(5813))))));
			register("query-string", "8.2.0", () => (__webpack_require__.e(865).then(() => (() => (__webpack_require__(246))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(7950))), 1);
			register("react-idle-timer", "5.7.2", () => (__webpack_require__.e(724).then(() => (() => (__webpack_require__(5343))))));
			register("react-redux", "9.2.0", () => (__webpack_require__.e(3).then(() => (() => (__webpack_require__(3003))))));
			register("react-router-dom", "6.30.1", () => (() => (__webpack_require__(5475))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(5043))), 1);
			initExternal(436);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};